import { TestKitType } from "@/common/types";
import { Button } from "@/components/ui/button";
import { getKitsPendingResultUpload } from "@/redux/actions/homeActions";
import { RootState } from "@/redux/reducers";
import { transformKitStatus } from "@/utils/common.util";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const PendingResultUpload = () => {
  const dispatch: any = useDispatch();

  const { kitsPendingResultUpload } = useSelector(
    (state: RootState) => state.home
  );

  const navigate = useNavigate();

  const handleClick = (id: number) => {
    navigate(`/test/${id}`);
  };

  useEffect(() => {
    dispatch(getKitsPendingResultUpload());
  }, []);

  return (
    <div className="w-full h-full flex flex-col border rounded-md">
      <p className="font-bold px-4 pt-4 pb-2 border-b">
        Kits Pending Result Upload
      </p>
      {(kitsPendingResultUpload as TestKitType[]).length > 0 &&
        (kitsPendingResultUpload as TestKitType[]).map((testKit) => (
          <div
            key={testKit.id}
            className="flex items-center justify-between gap-2 px-4 py-2"
          >
            <div>
              <p>{testKit.kit_id}</p>
            </div>
            <div className="flex flex-row items-center gap-2">
              <p className="bg-[#48B9B2] text-white text-sm px-3 py-1 rounded-full">
                {transformKitStatus(testKit.status)}
              </p>
              <Button
                variant="secondary"
                onClick={() => handleClick(testKit.id)}
              >
                View Test Kit
              </Button>
            </div>
          </div>
        ))}

      {(kitsPendingResultUpload as TestKitType[]).length === 0 && (
        <div className="flex items-center  gap-2 px-4 py-2 h-full">
          <p className="text-sm">No kits pending result upload</p>
        </div>
      )}
    </div>
  );
};

export default PendingResultUpload;
